import React, {useState} from "react";
import {light} from "../global.css";

const ThemeContextImpl = React.createContext({
        isDark:false
});

const Theme = ({children}: {children:React.ReactNode}) => {
    const [isDark, ] = useState<boolean>(false)

    document.body.className = light;
    return <ThemeContextImpl.Provider value={{isDark:isDark}}>
        <div id={"theme-container"}>
            {children}
        </div>
    </ThemeContextImpl.Provider>
}

export default Theme